export const REVENUE_COMPANY_FILTERS = {
  package_running: {
    key: 'package_running',
    title: 'On package — running',
    description: 'Restaurants with an assigned package and active access (not expired).',
    color: '#00acac',
    icon: 'fa-check-circle',
  },
  package_expired: {
    key: 'package_expired',
    title: 'On package — expired',
    description: 'Restaurants with a package assigned but access has expired.',
    color: '#f59c1a',
    icon: 'fa-clock',
  },
  no_package_running: {
    key: 'no_package_running',
    title: 'No package — running',
    description: 'Restaurants without a package but access is still active (e.g. trial).',
    color: '#348fe2',
    icon: 'fa-play-circle',
  },
  no_package_expired: {
    key: 'no_package_expired',
    title: 'No package — expired',
    description: 'Restaurants without a package and access has expired.',
    color: '#ff5b57',
    icon: 'fa-ban',
  },
};
